import { GridColumnHeaderParams, GridValidRowModel } from '@mui/x-data-grid-pro'
import cn from 'classnames'
import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import React from 'react'
import SvgTooltip from 'src/components/Svgs/SvgTooltip'

import styles from './DataGridHeaderCell.style'

export function renderHeader<Row extends GridValidRowModel>(
  params: GridColumnHeaderParams<Row>,
): React.ReactElement {
  const alignRight =
    (params.colDef.headerAlign ?? params.colDef.align) === 'right'
  return (
    <div className={cn({ alignRight })} css={styles}>
      <div className={'headerName'}>{params.colDef.headerName}</div>
      {params.colDef.description && (
        <TooltipIcon
          className={'headerDescriptionTooltip'}
          icon={<SvgTooltip viewBox="0 0 24 24" />}
          placement={'bottom-end'}
        >
          {params.colDef.description}
        </TooltipIcon>
      )}
    </div>
  )
}
